var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNumberThree = function SvgIconNumberThree(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.698 8.716c-.281.278-.454.685-.454 1.199a.5.5 0 1 1-1 0c0-.746.256-1.42.751-1.91.496-.49 1.192-.755 1.999-.755 1.452 0 2.65 1.23 2.65 2.665 0 .695-.234 1.318-.709 1.78a2.4 2.4 0 0 1-.348.28c.836.529 1.407 1.422 1.407 2.497 0 1.577-1.388 2.778-3 2.778s-3-1.201-3-2.778a.5.5 0 1 1 1 0c0 .94.85 1.778 2 1.778s2-.839 2-1.778c0-1.057-.875-1.924-2.036-2.008a.5.5 0 0 1 0-.998c.604-.043 1.02-.234 1.28-.487.255-.25.406-.601.406-1.064 0-.894-.76-1.665-1.65-1.665m-1.296.466c.281-.278.71-.466 1.296-.466z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 21.25a9 9 0 1 0 0-18 9 9 0 0 0 0 18m0 1c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10",
    clipRule: "evenodd"
  })));
};
export default SvgIconNumberThree;